const __WEBPACK_NAMESPACE_OBJECT__ = require("vue-virtual-scroller");